import React from 'react';
import { createContextAndProvider } from '@applied/utils/hooks/react_context';

import useUpdateThemeVariables from '../hooks/useUpdateThemeVariables';
import { DRAGONFRUIT_DARK_THEME } from '../themes/df_dark_theme';
import type { Theme } from '../themes/theme';
import type { UserInteractionTracker } from '../utils/user_interactions';

const DEFAULT_THEME = DRAGONFRUIT_DARK_THEME;

interface DragonfruitContext {
  trackUserInteraction: UserInteractionTracker | undefined;
}

export const {
  useConditionalContextValue: useDragonfruit,
  ContextProvider: DragonfruitContextProvider,
} = createContextAndProvider<DragonfruitContext>('dragonfruit');

type DragonfruitProviderProps = {
  children: React.ReactNode;
  trackUserInteraction?: UserInteractionTracker;
  theme?: Theme;
};

export function DragonfruitProvider({
  children,
  trackUserInteraction,
  theme = DEFAULT_THEME,
}: DragonfruitProviderProps): React.JSX.Element {
  useUpdateThemeVariables(theme); // Update theme variables in the DOM

  return (
    <DragonfruitContextProvider value={{ trackUserInteraction }}>
      {children}
    </DragonfruitContextProvider>
  );
}
